export const CartActionTypes = {
  ADD_ITEM: 'ADD_ITEM',
  CLOSE: 'CLOSE',
  OPEN: 'OPEN',
  REMOVE_ITEM: 'REMOVE_ITEM',
  RESET: 'RESET',
  SET_CURRENCY: 'SET_CURRENCY',
};
